export default "<div class=\"loader\">\r\n</div>\r\n";